import {Injectable} from '@angular/core';
import {groupMenu, MenuItem} from './model';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {CacheStore, SessionQuery} from 'phd-akita-session';
import {concatMap, map, tap} from 'rxjs/operators';
import {filterNil} from '@datorama/akita';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CacheService {

  public init$ = new BehaviorSubject(false);
  private restUrl = environment.baseUrl;

  constructor(private http: HttpClient,
              private sessQry: SessionQuery,
              private store: CacheStore) {
    this.signedInTrigger();
  }

  public getCache(name: string) {
    return this.store._value().data[name];
  }

  private loadMenuItem(): Observable<any> {
    return this.http.get<MenuItem[]>(this.restUrl + '/public/menus')
      .pipe(
        map(menus => groupMenu(menus)),
        tap(val => this.store.addCache('menuItems', val))
      );
  }

  private signedInTrigger() {
    this.sessQry.select(s => s.user)
      .pipe(filterNil, concatMap(_ => forkJoin([
        this.loadGeneralVariables(), this.loadMenuItem()
      ]))).subscribe(() => {
      this.init$.next(true);
    });
  }

  private loadGeneralVariables(): Observable<any> {
    return this.http.get(this.restUrl + '/general/global-variables')
      .pipe(
        tap(data =>
          Object.entries(data).forEach(([k, v]) => this.store.addCache(k, v))
        ));
  }


}

